var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paypal"},[_c('Spinner',{attrs:{"size":8,"thickness":3}}),_c('PaypalButtons',{staticClass:"buttons",style:(_vm.style),attrs:{"create-order":_vm.order,"on-init":_vm.init,"on-click":_vm.validate,"on-approve":_vm.approve,"on-error":_vm.error,"on-cancel":_vm.cancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }